import { FC } from 'react';
import { createZodFormResolver, Form, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useCommanderSelector } from '@mews-commander/utils';
import { SchemaFormDefinition, SchemaFormFields } from '@mews-commander/form';
import { FormLayout } from '../../FormLayout';
import { getTravelAgencyNumberFormInitialValues } from '../selectors';
import { TravelAgencyNumberFormSchema, TravelAgencyNumberFormValues } from './types';
import { useChangeTravelAgencyNumberMutation } from './useChangeTravelAgencyNumberMutation';

const formDefinition: SchemaFormDefinition<typeof TravelAgencyNumberFormSchema> = {
    fields: {
        channelNumber: {
            label: lt(TextKey.TravelAgencyConfirmationNumber),
        },
    },
};

interface TravelAgencyNumberFormProps {
    reservationIds: string[];
    scope: string;
    onSuccess?: () => void;
}

export const TravelAgencyNumberForm: FC<TravelAgencyNumberFormProps> = ({
    reservationIds,
    scope,
    onSuccess,
}: TravelAgencyNumberFormProps) => {
    const defaultValues = useCommanderSelector((state) => getTravelAgencyNumberFormInitialValues(state, { scope }));
    const mutation = useChangeTravelAgencyNumberMutation(reservationIds);

    const onSubmit = (values: TravelAgencyNumberFormValues) => {
        mutation.mutate(values, { onSuccess });
    };

    return (
        <Form
            onSubmit={onSubmit}
            resolver={createZodFormResolver(TravelAgencyNumberFormSchema)}
            values={defaultValues}
            dataTestForm="travel-agency-number-form"
        >
            <FormLayout loading={mutation.isPending} vertical={false}>
                <SchemaFormFields schema={TravelAgencyNumberFormSchema} formDefinition={formDefinition} />
            </FormLayout>
        </Form>
    );
};
